// extracted by mini-css-extract-plugin
export default {"flex_container":"VacnciesPageSite_flex_container__DJZO-","text":"VacnciesPageSite_text__15DBs","img":"VacnciesPageSite_img__YWbQD"};